// Financial-data permission bundle.
// Granting ALL of these = "can see all financial data"; granting NONE = financial UI + APIs hidden.
// Mirrors apiv2/src/modules/users/permissions/role-permissions.ts (FINANCIAL_PERMISSION_KEYS).
// KEEP THE TWO LISTS IN SYNC.
export const FINANCIAL_PERMISSION_KEYS = [
   'quotation.view',     // price offers / quotations
   'billing',            // invoices & billing
   'tax_documents.view', // tax documents
   'expenses.view',      // expenses
   'reports.view',       // reports (accounting, pivot)
   'analytics',          // analytics dashboards
];

// Admin-user marker: a child user whose permissions contain this key has the FULL owner
// (HallManager) permission set — including user management. Mirrors ADMIN_CHILD_MARKER on the
// backend (role-permissions.ts). KEEP IN SYNC.
export const ADMIN_CHILD_MARKER = 'admin';

// Granular per-user privilege keys managed by the add/edit-user toggles (besides the financial
// bundle above). Row scope: without the viewAll keys the user sees/edits only rows they're
// tagged in (as linked crew member / creator / owner).
export const VIEW_ALL_EVENTS_KEY = 'events.viewAll';
export const VIEW_ALL_MEETINGS_KEY = 'meetings.viewAll';
export const SEE_SETTINGS_KEY = 'settings.view';

// Experimental Inventory & Rentals module (מלאי והשכרות). Deliberately in NO role default —
// the whole module (sidebar, routes, API) exists only for explicitly tagged users. ROOT-ADMIN
// grants the key to the account owner (root-admin tenants screen); an owner who holds it tags
// children via the users screen. Owners can NOT self-opt-in. Mirrors INVENTORY_PERMISSION_KEY
// on the backend (role-permissions.ts). KEEP IN SYNC.
export const INVENTORY_KEY = 'inventory';

// שעון נוכחות manager: everyone's rows, the monthly report, corrections. Owners and admin users
// hold it through the owner role; a plain child gets it from the toggle on the users screen.
// Mirrors TIME_CLOCK_MANAGE_KEY on the backend (role-permissions.ts). KEEP IN SYNC.
export const TIME_CLOCK_MANAGE_KEY = 'time_clock.manage';

// The reception-desk login (עמדת אירוח): a child user carrying ONLY this marker — the toggles
// strip everything else when it is on. Defined in core/acl/venue.js; mirrors the backend.
export { HOSTING_STATION_MARKER } from './venue';
import { HOSTING_STATION_MARKER as _HOSTING_STATION_MARKER } from './venue';

// Every key the simple toggles own. Recomputing a user's permission array = (current array minus
// MANAGED_PRIVILEGE_KEYS) plus the keys the toggles grant — anything granted on the granular
// permissions page outside this list is preserved.
export const MANAGED_PRIVILEGE_KEYS = FINANCIAL_PERMISSION_KEYS.concat([
   ADMIN_CHILD_MARKER,
   VIEW_ALL_EVENTS_KEY,
   VIEW_ALL_MEETINGS_KEY,
   SEE_SETTINGS_KEY,
   INVENTORY_KEY,
   TIME_CLOCK_MANAGE_KEY,
   _HOSTING_STATION_MARKER,
]);

export default FINANCIAL_PERMISSION_KEYS;
